// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./src/index.tsx");
__webpack_require__("./node_modules/webpack-dev-server/client/index.js?http://172.18.0.3:8000");
var __webpack_exports__ = __webpack_require__("./node_modules/webpack/hot/dev-server.js");
